import { yup } from '@framework/validation';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { ConditionGroupExpressionSchema } from '../../../../expressions/repository/condition-group/ConditionGroupExpressionSchema';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent';
import { IComputedBooleanWidget } from '../IComputedWidget';

export const computedBooleanConfigSchema: yup.ObjectSchema<IComputedBooleanWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetType.ComputedBoolean)
      .label('Tipo'),
    expression: ConditionGroupExpressionSchema.required().label('Espressione'),
    text: RichTextAdvancedSchema.optional().label('Testo'),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
    }),
  });
